import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/catalog/coupons/create')({
  component: CreateCouponPage,
})

function CreateCouponPage() {
  // Redirect to main coupons page - we use drawer pattern now
  return <Navigate to='/catalog/coupons' />
}
